angular.module("qbePortal").controller("HomeFormController", [
	"$rootScope",
	"$scope",
	"dynamicRouter",
	"$state",
	"storage",
	"gtmService",
	"MAService",
	"Util",
	"userInputRepository",
	"portalServiceWrapper",
	"quoteOptions",
	"serviceResponseRepository",
	"quoteModelFactory",
	"paymentService",
	"$stateParams",
	"quoteRequestRepository",
	"$q",
	"tokenTimeoutService",
	"$compile",
	"$window",
	"smartLinkService",
	"campaignService",
	"embargoTestService",
	function (
		$rootScope,
		$scope,
		dynamicRouter,
		$state,
		storage,
		gtmService,
		MAService,
		util,
		userInputRepository,
		portalServiceWrapper,
		quoteOptions,
		serviceResponseRepository,
		quoteModelFactory,
		paymentService,
		$stateParams,
		quoteRequestRepository,
		$q,
		tokenTimeoutService,
		$compile,
		$window,
		smartLinkService,
		campaignService,
		embargoTestService
	) {
		var $ctrl = this;
		var MAX_ACCESSORY_VALUE = 5000;

		//check if session function is embedded and append directive
		if ($window.qbe.fieldLabels != undefined) {
			if (angular.isObject($window.qbe.fieldLabels.sessionFunction))
				angular
					.element("div#phglobaloptions_0_divOptionsComponents")
					.after($compile("<div qb-ng-dialog></div>")($scope));
		}

		/**
		 * routing initialisation, enabling/disabling (hiding/showing) available routes
		 * testing for allowed routes and redirecting when not allowed
		 */
		function initialiseRouting() {
			storage.removeItem("policy-date-input");

			var stepConditions = {
				"home.building": function () {
					return displayBuildingStep();
				},
				"home.payment": function () {
					return $state.$current.name != "home.done";
				},
				"home.done": function () {
					return $state.$current.name == "home.done";
				},
				"home.policy-start-date": function () {
					return $state.$current.name == "home.policy-start-date";
				},
			};
			dynamicRouter.initialise(
				$state.current.name,
				$state.$current.parent.name,
				stepConditions,
				markCompletedRouteCallback
			);
			$ctrl.title = dynamicRouter.getPageTitle();
			$ctrl.steps = dynamicRouter.getSteps();
		}

		function markCompletedRouteCallback(stateName) {
			storage.setItem("completed-step", stateName);
		}
		/** End of routing logic */

		function displayBuildingStep() {
			return !!userInputRepository.get(
				{},
				"homeForm.tellUsHowWeCanInsureYou.coverNeeds.building"
			);
		}

		$ctrl.validationErrors = null;
		$ctrl.sections = {};
		$ctrl.state = $state;
		$ctrl.isNextDisabled = false;
		$ctrl.storage = storage;
		$ctrl.formData = {};
		$ctrl.rapidEstimate = {};
		$ctrl.showRapidEstimate = false;
		$ctrl.pageState = {};
		$ctrl.convicitonDataObject = {};
		$ctrl.sideBarEmail = null;

		$ctrl.commonValues = {};

		$ctrl.quoteModel = quoteModelFactory.create();
		$ctrl.saveOnExit = false;
		$ctrl.smartLink = null;

		$window.onbeforeunload = function (event) {
			exitSaveQuote();
			if ($ctrl.saveOnExit) {
				$rootScope.$digest();
				return "Are you sure you want to leave?";
			}
		};

		$scope.$on("session-save-quote", exitSaveQuote);

		function exitSaveQuote() {
			var emailAddress = angular
				.element("div")
				.find("[label-key=yourEmailAddress]")
				.val();

			if (dynamicRouter.getPageTitle() != "Payment") {
				if (
					$ctrl.quoteModel.email != null ||
					$ctrl.sideBarEmail != null ||
					emailAddress != ""
				) {
					if ($ctrl.quoteModel && $ctrl.quoteModel.quoteResult) {
						$ctrl.saveOnExit = true;
						var formData = getUserInput();
						var paymentFrequency = "everyyear";

						portalServiceWrapper.updateQuote(formData);

						portalServiceWrapper
							.saveQuote(paymentFrequency, {
								quote: "true",
							})
							.then(function () {
								$rootScope.$broadcast("session-redirect");
							})
							.catch(function () {
								$rootScope.$broadcast("session-redirect");
							});
					} else {
						$rootScope.$broadcast("session-redirect");
					}
				} else $rootScope.$broadcast("session-redirect");
			}
		}

		// Broadcasts
		$rootScope.$broadcast("loading-animation-end");
		$rootScope.$broadcast("page-title-set", $ctrl.title);

		//Functions
		function scrollViewTo($element) {
			var offset = $element.offset();
			if (offset) {
				$("html, body").animate({
					scrollTop: offset.top - 50,
					scrollLeft: offset.left,
				});
			}
		}

		//Function call for Quick Quote
		function getQuickQuote(formData, callback) {
			portalServiceWrapper.updateQuote(formData);
			var quickQuoteOptions = quoteOptions.getOfferingPermutations(
				$state.current.name,
				getCoverOptions(formData)
			);
			if (quickQuoteOptions) {
				getQuickQuoteWith(quickQuoteOptions, callback);
			} else {
				return false;
			}
			return true;
		}

		function getRapidEstimate(formData, callback) {
			portalServiceWrapper.updateQuote(formData);
			var rapidEstimateOptions = quoteOptions.getOfferingPermutations(
				"rapidEstimate",
				getCoverOptions(formData)
			);
			getQuickQuoteWith(rapidEstimateOptions, callback);
		}

		function getQuickQuoteWith(quoteOptions, callback) {
			portalServiceWrapper
				.getQuickQuote(quoteOptions.permutations, quoteOptions.rules)
				.then(function (resp) {
					if (callback) callback(resp);
				})
				.catch(function (err) {
					broadcastError(err, "getQuickQuote error");
				});
		}

		function getRequote(formData, page, callback) {
			portalServiceWrapper.updateQuote(formData);
			var requoteOptions = quoteOptions.getOfferingPermutations(
				$state.current.name,
				getCoverOptions(formData)
			);
			if (requoteOptions) {
				portalServiceWrapper
					.getQuickQuote(
						requoteOptions.permutations,
						requoteOptions.rules
					)
					.then(function (resp) {
						if (callback) callback(resp);
					})
					.catch(function (err) {
						console.log(err);
						broadcastError(err, "Requote error");
					});
			} else {
				return false;
			}
			return true;
		}

		function getCoverOptions(formData) {
			if (formData.homeForm && formData.homeForm.tellUsAboutTheProperty) {
				return {
					homeOccupancy:
						formData.homeForm.tellUsAboutTheProperty
							.howIsHomeOccupied,
					buildingType:
						formData.homeForm.tellUsAboutTheProperty.typeOfBuilding,
					needs: formData.homeForm.tellUsHowWeCanInsureYou.coverNeeds,
					needRapidEstimate: true,
				};
			}

			throw "Not able to find the data for calculating permutations";
		}

		//Setting up initial values
		function getDefaultValues() {
			var defaultValues = {
				homeForm: {
					letsGetStarted: {
						startCoverDate: moment()
							.tz("Australia/Sydney")
							.format("DD/MM/YYYY"),
						personOrCompany: "person",
					},
					rapidEstimate: {
						needRapidEstimate: false,
					},
					mainPolicyHolderContact: {
						primaryPhone: "mobile",
					},
					additionalPolicyHolders: {
						primaryPhone: "mobile",
					},
					companyContactContact: {
						companyContactSamePostalAddress: true,
					},
					tellUsAboutTheBuilding: {
						homeLevels: "1",
					},
					mortgageOnProperty: {
						propertyMortgagedWith: [],
					},
					//quote page
					// confirmYourOptionalBenefits:{
					// 	accdLossDmgCoverBuilding: true,
					// 	accdLossDmgCoverContents: true
					// }
				},
			};

			var defaultStateExcess = quoteOptions.getStateDefaultVoluntaryExcess(
				$ctrl.quoteModel.state
			);
			if (defaultStateExcess != null) {
				var tempObj = {
					homeForm: {
						chooseYourExcess: {
							homeExcess: defaultStateExcess,
						},
					},
				};
				defaultValues = Object.extend(defaultValues, tempObj);
			}

			var defaultPortableContentStateExcess = quoteOptions.getStateDefaultVoluntaryExcess(
				$ctrl.quoteModel.state,
				1
			);
			if (defaultStateExcess != null) {
				var tempObj2 = {
					homeForm: {
						chooseYourExcess: {
							portableContentsExcess: defaultPortableContentStateExcess,
						},
					},
				};
				defaultValues = Object.extend(defaultValues, tempObj2);
			}

			return defaultValues;
		}

		function getUserInput() {
			var formData = getFormInput();
			userInputRepository.update(formData);
			return userInputRepository.get(getDefaultValues());
		}

		function getFormInput() {
			var formData = {};
			for (var key in $ctrl.sections) {
				formData[key] = $ctrl.sections[key].getValue();
			}

			if ($ctrl.sideBarEmail != null) {
				if (
					formData.homeForm.tellUsABitMore &&
					formData.homeForm.tellUsABitMore.yourEmailAddress
				)
					formData.homeForm.tellUsABitMore.yourEmailAddress =
						$ctrl.sideBarEmail;
				if (
					formData.homeForm.mainPolicyHolderContact &&
					formData.homeForm.mainPolicyHolderContact.emailAddress1
				)
					formData.homeForm.mainPolicyHolderContact.emailAddress1 =
						$ctrl.sideBarEmail;
			}

			return formData;
		}

		// This method does not work for arrays
		$ctrl.getFormItem = function (formNameWithField) {
			var finalValue = getFormInput();
			var items = formNameWithField.split(".");
			items.forEach(function (value, idx) {
				finalValue = finalValue[value];
			});
			return finalValue;
		};

		function proceedToNextStep(formData) {
			$rootScope.$broadcast("loading-animation-start");
			saveQuoteIfRequired(formData);
			testDeclineIfRequired(formData);
			$state.go(dynamicRouter.next(markCompletedRouteCallback));
		}

		function saveQuoteIfRequired(formData) {
			saveQuoteNotRequiredFor = []; // 'home.estimate' , 'home.property' , 'home.building' , 'home.covers', 'home.details', 'home.done'] ;
			var notRequired =
				saveQuoteNotRequiredFor.indexOf($state.$current.name) >= 0;
			if (!notRequired) {
				saveQuote(formData);
			}
		}

		$ctrl.back = function () {
			gtmService.trackEvent("back");
			$scope.$root.$broadcast("hide-top-banner");
			$scope.$broadcast("reset-field-errors");
			var backState = dynamicRouter.back();
			if (backState) $state.go(backState);
			else {
				var formData = getUserInput();
				if (formData.rapidEstimateUrl)
					window.location.href = formData.rapidEstimateUrl;
			}
		};

		function broadcastError(err, msg) {
			$rootScope.$broadcast("error", {
				errorMessage: msg,
				response: err,
			});
		}

		function saveQuote(formData, callback) {
			portalServiceWrapper.updateQuote(formData);

			var paymentFrequency = quoteOptions.getSelectedPaymentFrequencyForService();

			portalServiceWrapper
				.saveQuote(paymentFrequency)
				.then(function (resp) {
					$rootScope.$broadcast("loading-animation-end");
					var testEmbargo = embargoTestService.testEmbargoDecline(
						resp
					);

					if (testEmbargo != null) {
						$state.go(testEmbargo.declineType, testEmbargo);
						return false;
					}

					if (callback) callback(resp);
					return resp;
				})
				.catch(function (err) {
					if (tokenTimeoutService.isSessionTimedout()) {
						tokenTimeoutService.handleTimeout();
					} else {
						broadcastError(err, "Save quote error");
					}
					return err;
				});
		}

		$ctrl.save = function () {
			$ctrl.title = dynamicRouter.getPageTitle();

			$ctrl.showErrorSummary = false;
			isInvalid = $scope.homeForm.$invalid;
			if (isInvalid) {
				$scope.$broadcast("broadcast-field-errors");
				$ctrl.showErrorSummary = true;
				$scope.$broadcast("reset-field-errors");
				scrollViewTo($("#combinedValidationListing"));
				return;
			}

			getUserInput();
			setSelectedCoverType();
			$rootScope.$broadcast("open-modal", {
				modal: "saveQuote",
			});
		};

		$ctrl.getCoverType = function () {
			var formData = getUserInput();
			if (
				formData.homeForm.tellUsHowWeCanInsureYou &&
				formData.homeForm.tellUsHowWeCanInsureYou.coverNeeds
			) {
			} else {
				return null;
			}

			var building =
				formData.homeForm.tellUsHowWeCanInsureYou.coverNeeds.building;
			var content =
				formData.homeForm.tellUsHowWeCanInsureYou.coverNeeds.contents;

			if (building && content) {
				return "building_and_contents";
			} else if (building && !content) {
				return "building_only";
			} else if (!building && content) {
				return "contents_only";
			} else {
				return null;
			}
		};

		function clearPreviousQuotes() {
			serviceResponseRepository.update("quote", null);
			serviceResponseRepository.update("quickQuote", null);
			quoteRequestRepository.clearQuoteCredentials();
			quoteOptions.clearQuoteResults();
		}

		$ctrl.submitRapidEstimate = function (form) {
			var isInvalid = form.$invalid;
			if (isInvalid) {
				$scope.$broadcast("broadcast-field-errors");
				$ctrl.showErrorSummary = true;
				$scope.$broadcast("reset-field-errors");
				scrollViewTo($("#combinedValidationListing"));
				return;
			}

			gtmService.trackEvent("rapid-estimate-submit");

			clearPreviousQuotes();

			$rootScope.$broadcast("loading-animation-start");
			var formData = getUserInput();

			setSelectedCoverType();
			setOfferingOrDecline();
			getRapidEstimate(formData, function () {
				var quoteResults = serviceResponseRepository.getLastResponseFrom(
					"quickQuote"
				);
				$ctrl.showRapidEstimate = true;
				$scope.$root.$broadcast("process-rapid-estimates", {
					formData: formData,
					results: quoteResults,
				});
				$rootScope.$broadcast("loading-animation-end");
			});
		};

		/**
		 * message broadcasted by qbPaymentSummary to submit the form
		 */
		$scope.$on("form-submit", function (event, formName) {
			$ctrl.submit($scope[formName]);
		});

		/**
		 * message broadcasted by qbPaymentSummary to save the form
		 */
		$scope.$on("sidebar-save-quote", function (event, data) {
			$ctrl.sideBarEmail = data;
			$ctrl.save();
		});

		/**
		 * message broadcasted by qbPaymentSummary to assign the email address
		 */
		$scope.$on("sidebar-assign-mail", function (event, data) {
			if (data != "") $ctrl.sideBarEmail = data;
		});

		/*
		 * Emited by rapid estimate panel component
		 */
		$scope.$on("rapid-estimate-redirect", function () {
			$state.go(dynamicRouter.next(markCompletedRouteCallback));
		});

		$ctrl.submit = function (form) {
			$scope.$broadcast("form-submitted");
			var isInvalid = form.$invalid;
			if (isInvalid) {
				$scope.$broadcast("broadcast-field-errors");
				$ctrl.showErrorSummary = true;
				$scope.$broadcast("reset-field-errors");
				scrollViewTo($("#combinedValidationListing"));
				return;
			}
			gtmService.trackEvent("next");
			$scope.$root.$broadcast("loading-animation-start");
			var formData = getUserInput();

			checkEstimatedRebuildCost(formData);

			checkPrerequestDecline(formData);

			setSelectedCoverType();
			if (setOfferingOrDecline($state.$current.name == "home.estimate")) {
				var quickQuote = getQuickQuote(formData, function () {
					$ctrl.quoteModel = quoteModelFactory.create();
					$rootScope.$broadcast("perform-ma-service", "next");
					proceedToNextStep(formData);
				});
				if (!quickQuote) {
					proceedToNextStep(formData);
				}
			}
		};

		function checkSpotValue(quoteModel) {
			if (util.isUndefinedOrNull(quoteModel.cordelInfo)) {
				$state.go("referral", declineParams);
			}

			var sumInsured = util.isUndefinedOrNull(
				quoteModel.cordelInfo.spotValue
			)
				? 0
				: Math.floor(quoteModel.cordelInfo.spotValue);
			var lowerBand = util.isUndefinedOrNull(
				quoteModel.cordelInfo.lowerBand
			)
				? 0
				: Math.floor(quoteModel.cordelInfo.lowerBand);
			var declineParams = {
				declineType: "",
				declineCodes: "",
			};
			if (
				isNaN(sumInsured) ||
				sumInsured <= 0 ||
				isNaN(lowerBand) ||
				lowerBand <= 0
			) {
				$state.go("referral", declineParams);
			}
		}

		function checkEstimatedRebuildCost(formData) {
			if (
				formData.homeForm.yourBuilding &&
				formData.homeForm.yourBuilding.isEstimatedRebuildCost == "yes"
			) {
				var quoteModel = $ctrl.quoteModel;
				formData.homeForm.yourBuilding.buildingSumInsured = Math.floor(
					quoteModel.cordelInfo.spotValue
				);
			}

			if (
				formData.homeForm.confirmYourSumsInsured &&
				formData.homeForm.confirmYourSumsInsured
					.isYourEstimatedRebuildCost == "yes"
			) {
				var quoteModel = $ctrl.quoteModel;
				formData.homeForm.confirmYourSumsInsured.yourBuildingSumInsured = Math.floor(
					quoteModel.cordelInfo.spotValue
				);
			}
		}

		function setSelectedCoverType() {
			quoteOptions.setSelectedCoverType($ctrl.getCoverType(), "standard");
		}

		function setOfferingOrDecline(overwrite) {
			try {
				setSelectedOffering(overwrite);
				return true;
			} catch (ex) {
				/*
				 * this condition happens in case of no offering being available based on
				 * occupancy or other conditions.  This is condition happens for 'unoccupied' buildings
				 * at the moment.  @see HomeQuoteModel.getOfferings() for more details.
				 */
				declinePolicy({
					declineType: "decline",
				});
				return false;
			}
		}

		//!important - decline check is added in frontend as it is required for
		// release and GW wont be able to do that now
		function checkPrerequestDecline(formData) {
			var decline = false;

			if (
				formData.homeForm &&
				formData.homeForm.tellUsAboutTheProperty &&
				formData.homeForm.tellUsAboutTheProperty.address &&
				formData.homeForm.tellUsAboutTheProperty.address.state ==
					"AU_WA"
			) {
				//address in WA
				if (
					["duplex", "triplex", "villa", "townhouse"].indexOf(
						formData.homeForm.tellUsAboutTheProperty.typeOfBuilding
					) > -1
				) {
					// is 'duplex', 'triplex', 'villa', 'townhouse'
					if (
						formData.homeForm.tellUsAboutTheBuilding
							.isStrataRegdCorp === "yes"
					) {
						//managed by professional agent
						if (formData.homeForm.tellUsAboutTheBuilding) {
							if (
								formData.homeForm.tellUsAboutTheBuilding
									.areUnitAboveBelow === true
							) {
								//decline if units are above or below
								decline = true;
							} else {
								if (
									formData.homeForm.tellUsAboutTheBuilding
										.corpInsureUnit === "no"
								) {
									//decine if body corporate doesnt allows to insure
									decline = true;
								}
							}
						}
					}
				}
			}

			if (decline) {
				declinePolicy({
					declineType: "decline",
				});
			}
		}

		//sets the selected offering if none is available
		//overwrite - if true the offering is updated even if it is already available
		function setSelectedOffering(overwrite) {
			$ctrl.quoteModel = quoteModelFactory.create();
			var availableOfferings = $ctrl.quoteModel.getOfferings();
			if (overwrite) {
				quoteOptions.setSelectedOffering(availableOfferings[0]);
			} else {
				if (!quoteOptions.getSelectedOffering())
					quoteOptions.setSelectedOffering(availableOfferings[0]);
			}
		}

		//handler for the home Events
		$scope.$on("home-rapid-estimate", function (event, form) {
			$ctrl.submitRapidEstimate(form);
		});

		$ctrl.isRapidEstimateVisible = function () {
			if ($ctrl.commonValues.needRapidEstimate) {
				return true;
			} else {
				return false;
			}
		};

		$ctrl.refreshAddress = function () {
			$ctrl.formData = getUserInput();
			var address = null;
			if (
				$ctrl.formData.homeForm &&
				$ctrl.formData.homeForm.tellUsAboutTheProperty &&
				$ctrl.formData.homeForm.tellUsAboutTheProperty.address
			) {
				address =
					$ctrl.formData.homeForm.tellUsAboutTheProperty.address;
			}
			portalServiceWrapper.refreshAddress(address).then(
				function (resp) {
					serviceResponseRepository.update(
						"addressSearch",
						resp.data
					);
					$rootScope.$broadcast("update-quote-model-reference");
				},
				function (error) {
					console.log("No response from enrichment");
				}
			);
		};

		function testDeclineIfRequired(formData) {
			var declineTestRequiredFor = [
				"home.property",
				"home.building",
				"home.covers",
				"home.details",
				"home.quote",
				"home.contact",
			];
			var testRequired =
				declineTestRequiredFor.indexOf($state.$current.name) >= 0;
			if (testRequired) {
				testDecline(formData);
			}
		}

		function testDecline(formData) {
			portalServiceWrapper.updateQuote(formData);
			var declineQuoteOptions = quoteOptions.getTestQuoteDeclineOptions(
				$state.$current.name
			);
			portalServiceWrapper
				.testQuoteDecline(declineQuoteOptions)
				.catch(function (decline) {
					performMAServices("declined");
					declinePolicy(decline, "Policy Was Declined");
				});
		}

		function declinePolicy(decline) {
			var redirectPage = decline.declineType || "decline";

			//Check if needs to be redirected
			formData = getUserInput();

			if (
				formData.homeForm &&
				formData.homeForm.cycleCover &&
				formData.homeForm.cycleCover.coverItemsList
			) {
				var shouldRefer =
					getTotalValue(formData.homeForm.cycleCover.coverItemsList) >
					MAX_ACCESSORY_VALUE;
				if (shouldRefer) {
					redirectPage = "referral";
					decline.declineType = "referral";
				}
			}

			storage.clear();
			if (redirectPage == "referral") {
				$state.go(redirectPage, decline);
			} else {
				$state.go(redirectPage, decline);
			}
			// window.location.href = $ctrl.parentPath + '/home/' + redirectPage;
			return;
		}

		function getTotalValue(list) {
			var totalValue = 0;

			list.forEach(function (value) {
				totalValue += Number(value.value);
			});

			return totalValue;
		}

		/**
		 * QbFormSections register themselves with the form controller.
		 * This is done automatically by the form section upon initialisation.
		 * @name : name of the form section
		 * @init : function callback initialise the section
		 * @getValueFn: function callback to get the value of the section.
		 */
		$ctrl.registerSection = function (name, init, getValueFn) {
			$ctrl.sections[name] = {
				initValue: init,
				getValue: getValueFn,
			};
		};

		/**
		 * Takes care of
		 * - registering the labels generated by sitecore
		 * - setting default values
		 * - prepopulating retrieve quote if required.
		 */
		$ctrl.initPage = function () {
			initialiseRouting();
			// $ctrl.isNextDisabled = false;
			$scope.$on("disable-next", function (event, disable) {
				$ctrl.isNextDisabled = disable;
			});

			$scope.$on("conviction-check", function (event, convictionData) {
				// $ctrl.isNextDisabled = disable;
				if (convictionData) {
					$ctrl.convicitonDataObject[
						convictionData.conviction
					] = convictionData;
				}

				var disabled = false;
				for (var item in $ctrl.convicitonDataObject) {
					// console.log($ctrl.convicitonDataObject[item].section[$ctrl.convicitonDataObject[item].conviction].$name)
					if ($ctrl.convicitonDataObject[item].input === "unknown") {
						//additional check to see if the element exists on screen
						if (
							$(
								'[name="' +
									$ctrl.convicitonDataObject[item].section[
										$ctrl.convicitonDataObject[item]
											.conviction
									].$name +
									'"]'
							).length > 0
						) {
							disabled = true;
						}
					}
				}
				$ctrl.isNextDisabled = disabled;
			});

			// debugger;
			util.dispatchCustomEvent("register-labels");
			$ctrl.formData = getUserInput();
			var form = $ctrl.formData.homeForm;

			$ctrl.quoteModel = quoteModelFactory.create();

			if ($ctrl.state.current.name == "home.estimate") {
				invalidatePreviousQuote();
			}
			prepopulateRetrievedQuote();

			//enrich address
			$ctrl.refreshAddress();
			applyPromoCodeThroughLink();
			setWebBotValues();
		};

		function applyPromoCodeThroughLink() {
			if ($stateParams.promotionalCode) {
				var formData = $ctrl.formData;
				if (formData.homeForm) {
					formData.homeForm.tellUsABitMore =
						formData.homeForm.tellUsABitMore || {};
					formData.homeForm.tellUsABitMore.promotionalCode =
						$stateParams.promotionalCode;
				}
			}
		}

		function setWebBotValues() {
			if (
				$stateParams.isSyntheticTransaction_Ext &&
				$stateParams.syntheticSource_Ext
			) {
				var formData = $ctrl.formData;

				if (
					formData.homeForm &&
					$stateParams.isSyntheticTransaction_Ext == "true"
				) {
					formData.homeForm.isSyntheticTransaction_Ext =
						$stateParams.isSyntheticTransaction_Ext;
					formData.homeForm.syntheticSource_Ext =
						$stateParams.syntheticSource_Ext;
				}
			}
		}

		function prepopulateRetrievedQuote() {
			if ($stateParams.quoteNo && $stateParams.email) {
				gtmService.trackEvent("retrieve-quote");
				$rootScope.$broadcast("loading-animation-start");
				portalServiceWrapper
					.retrieveSavedQuote(
						$stateParams.quoteNo,
						$stateParams.email
					)
					.then(function (transformedQuote) {
						$q.when(
							portalServiceWrapper.refreshAddress(
								transformedQuote.tellUsAboutTheProperty.address
							)
						).then(function () {
							$ctrl.formData.homeForm = transformedQuote;
							var serviceResponse = storage.getItem(
								"service-response"
							);

							storage.setItem(
								"policy-address",
								serviceResponse.quote.policyAddress
							);

							userInputRepository.update($ctrl.formData);
							quoteOptions.setSelectedOffering(
								transformedQuote.info.offering
							);
							storage.setItem("retrieve", true);

							var testEmbargo = embargoTestService.testEmbargoDecline(
								serviceResponse
							);

							if (testEmbargo != null) {
								$state.go(testEmbargo.declineType, testEmbargo);
								return false;
							}

							if (
								moment()
									.tz("Australia/Sydney")
									.format("YYYY/MM/DD") >
								moment(serviceResponse.quote.periodStartDate)
									.tz("Australia/Sydney")
									.format("YYYY/MM/DD")
							) {
								storage.setItem(
									"policy-date-input",
									$ctrl.formData
								);
								$state.go(
									"home.policy-start-date",
									{
										quoteNo: "",
										email: "",
									},
									{
										location: true,
										reload: true,
									}
								);
							} else {
								$state.go(
									"home.property",
									{
										quoteNo: "",
										email: "",
									},
									{
										location: true,
										reload: true,
									}
								);
							}
						});
					})
					.catch(function () {
						var expiredQuote = storage.getItem("expired-quote");
						if (expiredQuote.displayStatus == "Expired") {
							storage.removeItem("expired-quote");
							window.location.href = util.linkBuilder(
								window.qbe.fieldLabels.expiredQuoteRedirect
									.homeExpired
							);
						}
					});
			}
		}

		//Updated data based on the common value
		function updateFormDataBasedOnCommonValues(name) {
			if (
				[
					"typeOfBuilding",
					"wallsMadeOf",
					"howIsHomeOccupied",
					"propertyProfessionalAgent",
				].indexOf(name) > -1
			) {
				$ctrl.formData = getUserInput();
				var formData = $ctrl.formData;
				//reset cover needs
				if (
					formData.homeForm.tellUsHowWeCanInsureYou &&
					formData.homeForm.tellUsHowWeCanInsureYou.coverNeeds
				) {
					formData.homeForm.tellUsHowWeCanInsureYou.coverNeeds = {};
				}

				$ctrl.formData = formData;
			}
		}

		$ctrl.initEstimatePage = function () {
			$ctrl.initPage();
			// $ctrl.refreshAddress();

			$scope.$root.$on("common-value-update", function (event, update) {
				$ctrl.commonValues[update.name] = update.value;
				updateFormDataBasedOnCommonValues(update.name);
			});

			var form = $ctrl.formData.homeForm;
			var quoteModel = $ctrl.quoteModel;

			if (form.rapidEstimate) {
				// form.rapidEstimate.needRapidEstimate = false;
				// QBE would like to keep this persistent.
			}
			$ctrl.formData.homeForm = form;
		};

		$ctrl.initPropertyPage = function () {
			// re-trigger pulsating icon to wait for the quote service return
			var triggerPulse = storage.getItem("retrieve");
			if (angular.equals(triggerPulse, {})) {
				$rootScope.$broadcast("loading-animation-start");
			}

			$ctrl.initPage();
			var form = $ctrl.formData.homeForm;
			var quoteModel = $ctrl.quoteModel;

			if (quoteModel.address.state === "AU_WA") {
				if (
					["unit", "flat"].indexOf(
						form.tellUsAboutTheProperty.typeOfBuilding
					) != -1 &&
					quoteModel.getHomeNeedType() != "contents_only" &&
					quoteModel.isBuildingFloodSafe()
				) {
					if (!form.tellUsAboutTheBuilding) {
						form.tellUsAboutTheBuilding = {};
					}
					form.tellUsAboutTheBuilding.isUnitAboveGround = false;
				} else {
				}
			}

			$ctrl.formData.homeForm = form;
		};

		$ctrl.initCoverPage = function () {
			$ctrl.initPage();
			var form = $ctrl.formData.homeForm;
			var quoteModel = $ctrl.quoteModel;

			if (quoteModel.dwelling.coverType !== "contents_only") {
				checkSpotValue(quoteModel);
			}

			if (form.tellUsHowWeCanInsureYou) {
				if (!form.portableContents) {
					form.portableContents = {};
					form.portableContents.coverPortableContents =
						form.tellUsHowWeCanInsureYou.needCoverOutsideHome ==
						true;
				}
			}

			if (form.rapidEstimate) {
				// copy quote/confirmYourSumsInsured to cover/yourBuilding values after requote
				if (form.confirmYourSumsInsured) {
					if (
						form.confirmYourSumsInsured.isYourEstimatedRebuildCost
					) {
						form.yourBuilding.isEstimatedRebuildCost =
							form.confirmYourSumsInsured.isYourEstimatedRebuildCost;
					}

					if (form.confirmYourSumsInsured.yourBuildingSumInsured) {
						form.yourBuilding.buildingSumInsured =
							form.confirmYourSumsInsured.yourBuildingSumInsured;
					}

					if (form.confirmYourSumsInsured.yourContentsSumInsured) {
						form.yourContents.contentsSumInsured =
							form.confirmYourSumsInsured.yourContentsSumInsured;
					}
				} else {
					if (!form.yourBuilding) {
						form.yourBuilding = {};

						if (form.rapidEstimate.buildingInsureAmount) {
							form.yourBuilding.buildingSumInsured =
								form.rapidEstimate.buildingInsureAmount;
						}
					}
					if (!form.yourContents) {
						form.yourContents = {};

						if (form.rapidEstimate.contentInsureAmount) {
							form.yourContents.contentsSumInsured =
								form.rapidEstimate.contentInsureAmount;
						}
					}
				}

				//set rent from rapid estimate if available
				if (!form.rentDefault) {
					form.rentDefault = {};

					form.rentDefault.rentDefault = true;
					if (form.rapidEstimate.rentDefaultCoverAmount) {
						form.rentDefault.rentCurrentWeekly =
							form.rapidEstimate.rentDefaultCoverAmount;
					}

					if (form.rapidEstimate.uptoWeeks) {
						form.rentDefault.rentXWeeks =
							form.rapidEstimate.uptoWeeks;
					}
				}
			}

			if (
				form.tellUsHowWeCanInsureYou &&
				form.tellUsHowWeCanInsureYou.coverNeeds &&
				form.tellUsHowWeCanInsureYou.coverNeeds.malicious_damage
			) {
				if (!form.theftAndVandalismByTenants) {
					form.theftAndVandalismByTenants = {
						theftCoverContents: true,
						theftCoverBuilding: true,
					};
				}
			}

			$ctrl.formData.homeForm = form;
		};

		$ctrl.initQuotePage = function () {
			$ctrl.initPage();

			var form = $ctrl.formData.homeForm;
			var quoteModel = $ctrl.quoteModel;

			if (!form.confirmYourLevelOfCover) {
				form.confirmYourLevelOfCover = {};
			}

			//sets selected offering
			var offering = quoteOptions.getSelectedOffering();
			if (offering.descriptor) {
				form.confirmYourLevelOfCover.yourChosenCover =
					offering.descriptor;
			} else {
				console.log("no offering selected");
			}

			//sets the sum insured
			if (!form.confirmYourSumsInsured) {
				form.confirmYourSumsInsured = {};
			}

			if (form.yourBuilding && form.yourBuilding.isEstimatedRebuildCost) {
				form.confirmYourSumsInsured.isYourEstimatedRebuildCost =
					form.yourBuilding.isEstimatedRebuildCost;
			}

			if (form.yourBuilding && form.yourBuilding.buildingSumInsured) {
				form.confirmYourSumsInsured.yourBuildingSumInsured =
					form.yourBuilding.buildingSumInsured;
			}

			if (form.yourContents && form.yourContents.contentsSumInsured) {
				form.confirmYourSumsInsured.yourContentsSumInsured =
					form.yourContents.contentsSumInsured;
			}

			if (
				form.portableContents &&
				form.portableContents.coverPortableContentLimit
			) {
				form.confirmYourSumsInsured.generalPortableContentsLimit =
					form.portableContents.coverPortableContentLimit;
			}

			//accidental Damage
			if (!form.confirmYourOptionalBenefits) {
				form.confirmYourOptionalBenefits = {};
			}
			if (
				form.accidentalLossOrDamage &&
				form.accidentalLossOrDamage.coverAccDmgBuilding
			) {
				// confirmYourOptionalBenefits
				form.confirmYourOptionalBenefits.accdLossDmgCoverBuilding =
					form.accidentalLossOrDamage.coverAccDmgBuilding == true;
			} else {
				form.confirmYourOptionalBenefits.accdLossDmgCoverBuilding = false;
			}

			if (
				form.accidentalLossOrDamage &&
				form.accidentalLossOrDamage.coverAccDmgContents
			) {
				form.confirmYourOptionalBenefits.accdLossDmgCoverContents =
					form.accidentalLossOrDamage.coverAccDmgContents == true;
			} else {
				form.confirmYourOptionalBenefits.accdLossDmgCoverContents = false;
			}

			if (
				form.domesticWorkerCompensation &&
				form.domesticWorkerCompensation.domesticWorkerCompCover
			) {
				form.confirmYourOptionalBenefits.domesticWrkCompCover =
					form.domesticWorkerCompensation.domesticWorkerCompCover ==
					true;
			} else {
				form.confirmYourOptionalBenefits.domesticWrkCompCover = false;
			}

			$ctrl.formData.homeForm = form;
			// getRequote(formData);
			// $scope.$broadcast('requote') ;
			console.log("Quote page init");
		};

		$ctrl.initContactPage = function () {
			$ctrl.initPage();
			setDefaultContactValues();
			// 	var form 		= $ctrl.formData.homeForm;
			// 	var quoteModel 	= $ctrl.quoteModel;
			//
			// 	// if ( !form.mainPolicyHolderContact ){
			// 	// 	form.mainPolicyHolderContact = {};
			// 	// 	form.mainPolicyHolderContact.primaryPhone = 'mobile';
			// 	// }
			//
			//
			//
			// 	$ctrl.formData.homeForm = form;
			//
		};

		function setDefaultContactValues() {
			var formData = getUserInput(),
				form = formData.homeForm,
				postalAddress = storage.getItem("policy-address");

			if (form.letsGetStarted.personOrCompany == "person") {
				form.mainPolicyHolder = form.mainPolicyHolder || {};

				form.mainPolicyHolderContact.personContactSamePostalAddress = true;

				if (form.mainPolicyHolderContact.address == undefined) {
					form.mainPolicyHolderContact.address =
						form.tellUsAboutTheProperty.address;
				}

				if (Object.keys(postalAddress).length > 0) {
					if (
						postalAddress.addressLine1 !==
							form.mainPolicyHolderContact.address.addressLine1 &&
						postalAddress.postalCode !==
							form.mainPolicyHolderContact.address.postalCode
					) {
						form.mainPolicyHolderContact.personContactSamePostalAddress = false;
						form.mainPolicyHolderContact.postalAddress = postalAddress;
					}
				}
			} else {
				if (Object.keys(postalAddress).length > 0) {
					if (
						postalAddress.addressLine1 !==
							form.companyContactContact
								.companyContactResidentialAddress
								.addressLine1 &&
						postalAddress.postalCode !==
							form.companyContactContact
								.companyContactResidentialAddress.postalCode
					) {
						form.companyContactContact.companyContactSamePostalAddress = false;
						form.companyContactContact.postalAddress = postalAddress;
					}
				}
			}
			$ctrl.formData.homeForm = form;
		}

		/**
		 * Initialisation method of the payment page
		 */
		$ctrl.initPaymentPage = function () {
			// $ctrl.storage.checkValidity();
			$ctrl.initPage();

			var form = $ctrl.formData.homeForm;
			var quoteModel = $ctrl.quoteModel;
			// $ctrl.termsAndConditions = false;
			//
			// var formData = getUserInput();
			// formData.paymentForm.paymentDetails.termsAndConditions = false ;
			// $ctrl.formData = formData ;
			//
			// getQuickQuote(formData);
			$scope.$on("payment-method-changed", function (
				event,
				paymentMethod
			) {
				$ctrl.paymentMethod = paymentMethod;
			});

			$scope.$on("terms-and-conditions-changed", function (
				event,
				termsAndConditions
			) {
				$ctrl.termsAndConditions = termsAndConditions;
			});
		};

		function constructDonePageViewModel() {
			var done = {
				policyNumber: $stateParams.policyNumber,
				accountNumber: $stateParams.accountNumber,
				isAwaitingProcess: $stateParams.isAwaitingProcess,
				policyType: $ctrl.quoteModel.getSelectedOffering().label,
				policyStartDate: $ctrl.quoteModel.policyStartDate,
				address: $ctrl.quoteModel.address,
				purchaseDate: moment()
					.tz("Australia/Sydney")
					.format("DD/MM/YYYY"),
				smartLinkURL: $window.qbe.fieldLabels.smartLink.url,
				hashKey: $window.qbe.fieldLabels.smartLink.hashKey,
				email: $ctrl.quoteModel.email,
				description: "Home Insurance",
				productRefs: "Home Insurance",
			};

			if ($ctrl.quoteModel.homeForm.mainPolicyHolder) {
				done.policyHolderName =
					$ctrl.quoteModel.homeForm.mainPolicyHolder.firstName +
					" " +
					$ctrl.quoteModel.homeForm.mainPolicyHolder.lastName;
			} else if ($ctrl.quoteModel.homeForm.companyContact) {
				done.policyHolderName =
					$ctrl.quoteModel.homeForm.companyContact.firstName +
					" " +
					$ctrl.quoteModel.homeForm.companyContact.lastName;
				done.email = $ctrl.quoteModel.homeForm.companyContact.email;
			}

			return done;
		}

		$ctrl.initDonePage = function () {
			$ctrl.initPage();

			var quoteModel = $ctrl.quoteModel;
			var done = storage.getItem("done");
			if (!done || !done.policyNumber) {
				done = constructDonePageViewModel();
				$ctrl.smartLink = smartLinkService.generateLink(done);
				gtmService.trackTransaction(
					$state.current,
					done,
					$ctrl.quoteModel
				);
				performMAServices("paid");
			}

			$ctrl.storage.clear();
			storage.setItem("done", done);
			var $columns = $(".columns").get(0);
			$columns.classList.remove("print-ready");
			$ctrl.done = done;
			$ctrl.done.campaignSteps = {};

			// check if campaign code is valid
			if (
				quoteModel.quoteResult.response.isCampaignCodeValid ||
				quoteModel.quoteResult.response.isGiftCardApplied
			) {
				// get campaign next steps
				$ctrl.done.campaignSteps = campaignService.getCampaignConfig(
					quoteModel.quoteResult.response.campaignCode,
					true
				);
			} else $ctrl.done.campaignSteps.isCampaignCodeValid = false;
		};

		$scope.$on("submit-feedback", submitFeedback);

		function submitFeedback() {
			if ($ctrl.done.policyNumber != null && $ctrl.smartLink != null) {
				window.open($ctrl.smartLink, "_blank");
			} else {
				console.log("No Smartlink generated!");
			}
		}

		//Events
		/**
		 * Any generic breaking errors should broadcast 'error' to the rootScope. This will cause redirection
		 * to the main error page.
		 */
		$scope.$on("error", function (event, error) {
			$state.go("error", error);
		});

		/**
		 * calls MA Services to add marketing data.
		 */
		$scope.$on("perform-ma-service", function (event, triggeredBy) {
			performMAServices(triggeredBy);
		});

		/**
		 * Enrich address on address selection
		 */
		$scope.$on("enrich-address", function (value) {
			$ctrl.refreshAddress();
		});

		$scope.$on("back", function () {
			gtmService.trackEvent("back");
			$ctrl.back();
		});

		$scope.$on("invalidate-quotes", invalidatePreviousQuote);

		function invalidatePreviousQuote() {
			serviceResponseRepository.update("quote", null);
			quoteRequestRepository.clearQuoteCredentials();
			storage.removeItem("policy-address");
		}

		/**
		 * called from qbFormSection and any other panel that requires a requote based on new values.
		 */
		$scope.$on("requote", function (event, form) {
			gtmService.trackEvent("requote");
			$rootScope.$broadcast("loading-animation-start");
			var formData = getUserInput();

			checkEstimatedRebuildCost(formData);

			getRequote(formData, null, function (resp) {
				$rootScope.$broadcast("loading-animation-end");
				$rootScope.$broadcast("quote-received", resp);
				$rootScope.$broadcast("selected-quote-changed");
			});
		});

		/**
		 * message broadcasted by qbFormSection.directive to move to a page
		 */
		$scope.$on("moveToPage", function (event, page) {
			$ctrl.moveToPage(page);
		});

		$ctrl.moveToPage = function (page) {
			$state.go(page);
		};

		function performMAServices(eventName) {
			getUserInput();
			var mainPolicyHolder = userInputRepository.get(
				{},
				"homeForm.mainPolicyHolder"
			);
			var policyEmail = userInputRepository.get({}, "email");
			if (policyEmail) {
			} else {
				policyEmail = userInputRepository.get(
					{},
					"homeForm.tellUsABitMore.yourEmailAddress"
				);
			}
			var quoteResult = quoteOptions.getSelectedQuoteResult();
			var savedQuote = serviceResponseRepository.getLastResponseFrom(
				"quote"
			);
			var quoteModel = $ctrl.quoteModel;
			var maData = {
				state: quoteModel ? quoteModel.state : null,
				postCode: quoteModel ? quoteModel.postCode : null,
				campaignCode: quoteModel ? quoteModel.campaignCode : null,
				pageName: $state.current.name,
				mainPolicyHolder: mainPolicyHolder,
				policyEmail: policyEmail,
				annualResult: quoteResult ? quoteResult.getAnnual() : null,
				monthlyResult: quoteResult ? quoteResult.getMonthly() : null,
				quoteId: savedQuote ? savedQuote.quoteID : null,
			};

			if ($state.current.name == "home.done") {
				maData.inceptionDate = moment()
					.tz("Australia/Sydney")
					.format("DD/MM/YYYY");
			}

			if (
				quoteModel &&
				quoteModel.address &&
				quoteModel.address.addressLine1
			) {
				maData.address =
					quoteModel.address.addressLine1 +
					" " +
					quoteModel.address.city;
			}

			if (
				quoteModel &&
				quoteModel.homeForm &&
				quoteModel.homeForm.mainPolicyHolderContact &&
				quoteModel.homeForm.mainPolicyHolderContact.contactNumber
			) {
				maData.contactNumber =
					quoteModel.homeForm.mainPolicyHolderContact.contactNumber;
			}

			MAService.mergeContacts(eventName, maData);
		}
	},
]);
